import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {Grid} from 'react-bootstrap';
import PropTypes from 'prop-types';
import {List} from 'immutable';

import Breadcrumbs from '../../breadcrumbs';
import {Wrapper} from 'system/wrapper';
import CardsPersonal from 'system/cards-personal';
import Spinner from 'spinner';
import Input from 'form/input';
import Pagination from 'pagination';
import {UniversalSearchWrapper} from 'components/common';
import {ButtonDefault} from 'components/buttons';
import doctor from 'images/general/doctor.svg';

import {loadInstitutionPersonalById, searchInstitutionPersonal, loadInstitutionDetail} from 'redux/actions/portal/institutions';


const mapStateToProps = (state) => ({
  personal: state.institutions.get('institutionPersonal'),
  isFetching: state.institutions.get('institutionsIsLoading'),
  institutionDetail: state.institutions.get('institutionDetail')
});

const mapDispatchToProps = (dispatch) => ({
  onLoad: (id, offset) => dispatch(loadInstitutionPersonalById(id, 12, offset)),
  onSearch: (id, name, offset) => dispatch(searchInstitutionPersonal(id, name, 12, offset)),
  loadInstitutionDetail: (id) => dispatch(loadInstitutionDetail(id))
});

class InstitutionPersonal extends Component {

  constructor(props) {
    super(props);

    this.state = {
      name: "",
      notFound: false,
      noContent: false
    }

    this.changeSearchName = this.changeSearchName.bind(this);
  }

  changeSearchName(event) {
    this.setState({
      name: event.target.value
    })
  }

  handleSearchClick = event => {
    event.preventDefault();
    this.props.match.params.page != 1
      ? this.props.history.push(`/institutions/detail/${this.props.match.params.id}/personal/page1`)
      : this.props.onSearch(this.props.match.params.id, this.state.name, 0)
  }

  renderBreadcrumbs = () => (
    <Breadcrumbs>
      <li><Link to="/">Головна</Link></li>
      <li><Link to="/institutions">Установи</Link></li>
      <li><Link to={`/institutions/detail/${this.props.match.params.id}`}>{this.props.institutionDetail.get('short_title')}</Link></li>
      <li><Link to={`/institutions/detail/${this.props.match.params.id}/personal`}>Персонал</Link></li>
    </Breadcrumbs>
  )

  renderPageContent = () => this.props.isFetching && <Spinner/>

  renderNoContent = () => this.state.noContent &&
    <h2>Інформація про персонал відсутня
      <p onClick={() => this.props.history.push(`/institutions/detail/${this.props.match.params.id}`)}>Повернутися до установи</p>
    </h2>

  renderNotFound = () => this.state.notFound &&
    <h2>За таким запитом лікарі відсутні
      <p onClick={() => this.props.history.push(`/institutions/detail/${this.props.match.params.id}`)}>Повернутися до установи</p>
    </h2>

  renderCards = () =>
    <CardsPersonal>
      {this.props.personal.get('results').map((item, i) => (
        <li key={i}>
          <Link to={`/institutions/detail/${this.props.match.params.id}/personal/${item.get('id')}`}>
            {item.get('user_data').get('photo') ? (
              <div style={{width: "60%", backgroundImage: `url(${item.get('user_data').get('photo')})`, backgroundSize: "cover", backgroundRepeat: "no-repeat", backgroundPosition: "center"}}> </div>
            ):(
              <div style={{width: "60%", backgroundImage: `url(${doctor})`, backgroundSize: "150px", backgroundRepeat: "no-repeat", backgroundPosition: "center"}}> </div>
            )}
            <div style={{maxWidth: '60%', wordWrap: 'break-word'}}>
              <h3>{item.get('user_data').get('last_name')} {item.get('user_data').get('first_name')} {item.get('user_data').get('middle_name')} </h3>
              <p><span>Посада: </span>{item.get('position_title')}</p>
            </div>
          </Link>
        </li>
      ))}
    </CardsPersonal>

  componentDidMount() {
    const page = this.props.match.params.page || 1;
    const offset = 12 * (page - 1);
    this.props.onLoad(this.props.match.params.id, offset);
    if(!this.props.institutionDetail){
      this.props.loadInstitutionDetail(this.props.match.params.id)
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.match.params.page !== nextProps.match.params.page) {
      const page = nextProps.match.params.page || 1;
      const offset = 12 * (page - 1);
      this.props.onSearch(this.props.match.params.id, this.state.name, offset);
    }
    const isSearchQuery = this.state.name
    if (isSearchQuery && nextProps.personal && nextProps.personal.get('results').size === 0){
      this.setState(() => ({ notFound: true, noContent: false }))
    } else if (nextProps.personal && nextProps.personal.get('results') && nextProps.personal.get('results').size === 0){
      this.setState(() => ({ noContent: true, notFound: false }))
    } else {
      this.setState(() => ({ notFound: false, noContent: false }))
    }
  }

  render() {

    if (!this.props.personal || !this.props.personal.get('results') || !this.props.institutionDetail) {
      return (
        <Wrapper>
          <Spinner/>
        </Wrapper>
      ); 
    }

    return (
      <div>
        {this.renderBreadcrumbs()}
        <Wrapper>
          <Grid>
            <h2>Персонал закладу</h2>
            <UniversalSearchWrapper onSubmit={this.handleSearchClick}>
              <Input
                block
                placeholder="Введіть посаду чи прізвище персоналу"
                label="Пошук персоналу"
                value={this.state.name}
                onChange={this.changeSearchName}
              />
              <ButtonDefault type="submit" value="Пошук" />
            </UniversalSearchWrapper>
            {this.renderPageContent()}
            {this.renderNoContent()}
            {this.renderNotFound()}
            {this.renderCards()}
            <Pagination counts={this.props.personal.get('count')} path={`/institutions/detail/${this.props.match.params.id}/personal/page`} matched={this.props.match.params.page} limits={12} />
          </Grid>
        </Wrapper>
      </div>
    )
  }
}

InstitutionPersonal.propTypes = {
  personal: PropTypes.instanceOf(List),
  isFetching: PropTypes.bool,
  onLoad: PropTypes.func
};


export default connect(mapStateToProps, mapDispatchToProps)(InstitutionPersonal);



// WEBPACK FOOTER //
// ./src/system/main/institutions/personal.js